import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let CountriesMultiSelect = class CountriesMultiSelect extends Vue {
    constructor() {
        super(...arguments);
        this.MaxVisibleChips = 3;
        this.search = null;
    }
    get HasSearch() {
        return !!this.search && this.search.trim().length > 0;
    }
    // Items the toggle acts on: the filtered results while searching, otherwise the whole list
    get TargetUuids() {
        if (!this.HasSearch)
            return this.items.map(item => item.uuid);
        const query = this.search.trim().toLowerCase();
        return this.items
            .filter(item => (item.name || "").toLowerCase().includes(query))
            .map(item => item.uuid);
    }
    get AllTargetsSelected() {
        return this.TargetUuids.length > 0 && this.TargetUuids.every(uuid => this.value.includes(uuid));
    }
    get SomeTargetsSelected() {
        return this.TargetUuids.some(uuid => this.value.includes(uuid));
    }
    get ToggleIcon() {
        if (this.AllTargetsSelected)
            return "mdi-checkbox-marked";
        if (this.SomeTargetsSelected)
            return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
    }
    get ToggleLabel() {
        if (this.AllTargetsSelected)
            return this.$t("options.deselect_all");
        if (this.HasSearch)
            return this.$t("options.select_filtered", { count: this.TargetUuids.length });
        return this.$t("options.select_all");
    }
    ToggleAll() {
        const targets = this.TargetUuids;
        if (this.AllTargetsSelected) {
            this.OnInput(this.value.filter(uuid => !targets.includes(uuid)));
        }
        else {
            this.OnInput(Array.from(new Set([...this.value, ...targets])));
        }
    }
    RemoveItem(uuid) {
        this.OnInput(this.value.filter(item => item !== uuid));
    }
    OnInput(value) {
        this.$emit("input", value || []);
    }
};
__decorate([
    Prop({ default: () => [] })
], CountriesMultiSelect.prototype, "value", void 0);
__decorate([
    Prop({ default: () => [] })
], CountriesMultiSelect.prototype, "items", void 0);
CountriesMultiSelect = __decorate([
    Component({
        components: {},
    })
], CountriesMultiSelect);
export default CountriesMultiSelect;
